import React from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const PageTitle = styled(Box)({
    '& .subtitle': {
        color: '#9B9B9B',
        fontSize: '12px',
    },
    '& .title': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
});

export default function (props) {
    return (
        <PageTitle>
            <div className="subtitle">{props.subtitle}</div>
            <div className="title">{props.title}</div>
        </PageTitle>
    )
}